/* eslint-disable no-loss-of-precision */
/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  updateShipment,
  clearUpdateShipment,
  clearCreateChildShipment,
  clearChildPacketIds,
  clearBarcodeId,
} from "../../../actionsMethods/cashBookingMethods";
import Alert from "../Alerts";

import {
  Form,
  Row,
  Col,
  Input,
  Select,
  message,
  Modal,
  Upload,
  Button,
} from "antd";
import uploadLogo from "../../../assests/images/bx_upload.svg";
import { HeaderWithBottomLine } from "../../Master/CpOnbordingSteps/HeaderWithBottomLine";
import { Radio } from "antd";
import { APIs, getToken } from "../../../utils/worker";
import { StarOutlined } from "@ant-design/icons";
import axios from "axios";

const ServiceDetails = ({
  currentScreen,
  allData,
  screen,
  reRenderCallback,
}) => {
  const [form] = Form.useForm();
  const [fileList, setfileList] = useState([]);
  const [filesData, setFileData] = useState([]);
  const [alertData, setAlertData] = useState(false);

  const dispatch = useDispatch();
  const getUpdateShipmentResponse = useSelector(
    (state) => state.appReducer.getUpdateShipmentReducer
  );
  const { result, error, fetching } = getUpdateShipmentResponse;

  const [userInfo, setUserInfo] = useState();
  console.log(result);

  useEffect(() => {
    if (result !== null && !fetching) {
      setAlertData({
        visible: true,
        message: "Booking successfully completed",
        data: result,
      });

      dispatch(clearCreateChildShipment());
      dispatch(clearChildPacketIds());
      // dispatch(clearUpdateShipment());
      dispatch(clearBarcodeId());
      reRenderCallback();
      setfileList([]);
      setFileData([]);
      screen(0);
    }
    if (error) {
      message.error(error?.message || "Booking Failed");
      dispatch(clearUpdateShipment());
    }
  }, [result, error, fetching]);

  const serviceType = () => {
    let serviceType = "1";
    let data = allData;
    let selectedMode = data?.service;
    if (selectedMode === "2") {
      serviceType = "Fast Track";
    }
    if (selectedMode === "3") {
      serviceType = "Value Plus";
    }
    if (selectedMode === "1") {
      serviceType = "Standard";
    }
    return serviceType;
  };

  const onSubmit = (values) => {
    let newdata = {
      addressDetails: {
        senderName: allData?.senderName,
        senderAddressLine1: allData?.senderAddressLine1,
        senderAddressLine2: allData?.senderAddressLine2,
        senderPincode: +allData?.senderPincode,
        senderCity: allData?.senderCity,
        senderState: allData?.senderState,
        senderMobileNumber: +allData?.senderMobileNumber,
        senderEmail: allData?.senderEmail || "",
        senderArea: allData?.senderAreaName || "",
        senderGst: allData?.addressDetails?.GSTnumber,
        senderPan: allData?.senderPan,
        customerId: 1960581322055966062,
        receiverName: allData?.receiverName,
        receiverAddressLine1: allData?.receiverAddressLine1,
        receiverAddressLine2: allData?.receiverAddressLine2,
        receiverCity: allData?.receiverCity,
        receiverPincode: +allData?.receiverPincode,
        receiverState: allData?.receiverState,
        receiverAreaId: 1,
        receiverAreaName: allData?.area,
        receiverMobileNumber: +allData?.receiverMobilenumber,
        receiverEmail: allData?.receiverEmail || "",
      },
      shipmentDetails: {
        type: allData?.docType,
        description: allData?.description,
        content: allData?.content,
        value: +allData?.valueInrNonDox || 0,
        weight: +allData?.weight || null,
        width: +allData?.width || null,
        height: +allData?.height || null,
        length: +allData?.length || null,
        ewayBillNumber: values?.ewayBillNo,
        destinationPincode: +allData?.deliveryPincode,
        service: 1,
        destinationCpId: allData?.ss[0]?.premiseId,
        destinationHubId: allData?.ss[0]?.parentId,
        premiseId: userInfo?.userInfo?.premiseId,
        userID: userInfo?.userInfo?.userId,
        bookingType: "Account",
        volumetricWeight: +allData?.totalVolWeight,
        clientName: allData?.client,
        expectedDeliveryDate: allData?.expectdDelivery,
      },
      serviceDetails: {
        service: serviceType(),
        travelBy: allData?.travelBy,
      },

      file: filesData?.length
        ? filesData?.map((val) => ({
            fileName: val?.filePath,
            fileId: val?.id,
          }))
        : [],
      bookingStatus: "UPDATED",
      local: false,
    };
    dispatch(updateShipment(newdata, allData?.awbNumber));
  };

  useEffect(() => {
    setUserInfo(JSON.parse(localStorage.getItem("userId")));
    let data = allData;

    if (data !== null) {
      form.setFieldsValue({
        type_: data?.docType,
        service: serviceType(),
        travelBy: data?.travelBy,
        content: data?.content,
        description: data?.description,
        // E-wayBillNo:data,
        weightInGms: data?.weight,
        weight: data?.weight,
        length: data?.length,
        width: data?.width,
        height: data?.height,
        totalVolWeight: data?.totalVolWeight,
        gstNumber: data?.addressDetails?.GSTnumber,
        fov: "no",
        cod: "no",
      });
    }
  }, [currentScreen]);

  const { Dragger } = Upload;

  let authToken = getToken();

  const props = {
    name: "files",
    multiple: true,
    listType: "picture",
    showUploadList: true,

    action: `${APIs.baseURL}/file-service/v1/file`,
    headers: { Authorization: ` ${authToken}` },

    className: "upload-list-inline",
    // onDrop(e) {
    //   console.log("Dropped files", e.dataTransfer.files);
    // },

    onChange(info) {
      if (info.file.status === "done") {
        // Handle response from API
      }
    },

    removeIcon: (
      <StarOutlined
      // onClick={(e) => console.log(e, "custom removeIcon event")}
      />
    ),
  };

  const handleChange = (info) => {
    let allFiles = info?.fileList?.map((val) => val?.response?.data);
    // let v1 = allFiles?.map((val) => val?.displayName);

    if (info.file.status === "done") {
      message.success(info.file.response.message);
      setFileData(allFiles);
    }
    if (info.file.status === "removed") {
      setFileData(allFiles);

      localStorage.setItem("allFiles", JSON.stringify(allFiles));
    }
    if (info.file.status === "error") {
      message.error("File not Supported");
    }
    setfileList(info.fileList);
  };

  const handleRemove = (file) => {
    const { confirm } = Modal;
    let config = {
      headers: {
        Authorization: authToken,
      },
    };
    return new Promise((resolve, reject) => {
      confirm({
        title: "Are you sure you want to Delete ?",
        onOk: async () => {
          resolve(true);
          try {
            let res = await axios.delete(
              `${APIs.baseURL}/file-service/v1/file/${file?.response?.data?.id}`,
              config
            );

            if (res) {
              message.success(res.data);
            }
          } catch (error) {
            // message.error(error.data + "world");
          }
        },
        onCancel: () => {
          reject(true);
        },
      });
    });
  };

  const beforeUpload = (file, onSuccess) => {
    const isJpgOrPng =
      file.type === "image/jpeg" ||
      file.type === "image/png" ||
      file.type === "application/pdf";
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (file) {
      let checkSameFile = fileList
        ?.map((val) => val?.name)
        .some((val) => val === file.name);

      if (file.name.includes("jfif")) {
        message.error("File not supported");
        return Upload.LIST_IGNORE;
      }
      if (checkSameFile) {
        message.error("Same file cannot be uploaded again");
        return Upload.LIST_IGNORE;
      }
      if (!isLt2M) {
        message.error("File size should be less than 2MB");
        return Upload.LIST_IGNORE;
      }
      if (!isJpgOrPng) {
        message.error("File not supported");
        return Upload.LIST_IGNORE;
      }
      return isJpgOrPng && isLt2M;
    } else {
      if (onSuccess) {
        message.success("File uploaded");
      }
      onSuccess("ok");
      return true;
    }
  };
  const lg = 12;
  const sm = 6;

  return (
    <div style={{ padding: "51px 59px 0" }}>
      {alertData && <Alert alertData={alertData} allData={allData} />}

      <Form
        form={form}
        name="serviceDetails"
        onFinish={onSubmit}
        layout="vertical"
        scrollToFirstError={{
          behavior: "smooth",
          block: "center",
          inline: "center",
        }}
        className="global-form step-2-form"
      >
        <div>
          <HeaderWithBottomLine text={"Service Details"} icon={false} />
          <Row className="global-form-row" gutter={40}>
            <Col lg={lg} sm={sm}>
              <Form.Item name="type_" label="Type">
                <Input disabled={true} readOnly={true} />
              </Form.Item>
            </Col>
            <Col lg={lg} sm={sm}>
              <Form.Item name="service" label="Service">
                <Input disabled={true} readOnly={true} />
              </Form.Item>
            </Col>
            <Col lg={lg} sm={sm}>
              <Form.Item name="travelBy" label="Travel by">
                <Input disabled={true} readOnly={true} />
              </Form.Item>
            </Col>
            <Col lg={lg} sm={sm}>
              {/* <Form.Item name="content" label="Content"> */}
              <Form.Item name="content" label="Content">
                <Select
                  placeholder="Select a content"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  readOnly={true}
                  disabled={true}
                  options={[
                    {
                      value: "Document",
                      label: "Document",
                    },
                  ]}
                ></Select>
              </Form.Item>
            </Col>
            <Col lg={lg} sm={sm}>
              <Form.Item name="description" label="Description">
                <Select
                  placeholder="Select a content"
                  optionFilterProp="children"
                  readOnly={true}
                  disabled={true}
                  options={[
                    {
                      value: "Document",
                      label: "Document",
                    },
                  ]}
                ></Select>
              </Form.Item>
            </Col>
            {!allData?.docType == "Non-dox" && (
              <Col lg={lg} sm={sm}>
                <Form.Item name="weightInGms" label="Weight (Gms)">
                  {/* <Form.Item name="weightInGms" label="Weight (Gms)">  */}
                  <Input disabled={true} readOnly={true} />
                </Form.Item>
              </Col>
            )}

            {allData?.docType == "Non-dox" && (
              <>
                <Col lg={12} sm={6}>
                  <Form.Item
                    label={
                      <span className="calculater-container-pikpin">
                        {" "}
                        Weight(Kg)
                      </span>
                    }
                    name="weight"
                  >
                    <Input
                      placeholder="Enter weight"
                      disabled={true}
                      readOnly={true}
                    />
                  </Form.Item>
                </Col>
                <Col lg={12} sm={6}>
                  <Form.Item
                    label={
                      <span className="calculater-container-pikpin">
                        {" "}
                        Length(Cm)
                      </span>
                    }
                    name="length"
                  >
                    <Input
                      placeholder="Enter length"
                      maxLength={3}
                      disabled={true}
                      readOnly={true}
                      // disabled={createChildShipmentResult !== null && true}
                    />
                  </Form.Item>
                </Col>
                <Col lg={12} sm={6}>
                  <Form.Item label=" Width(Cm)" name="width">
                    <Input
                      placeholder="Enter width"
                      min={"0"}
                      disabled={true}
                      readOnly={true}
                      // disabled={createChildShipmentResult !== null && true}
                    />
                  </Form.Item>
                </Col>
                <Col lg={12} sm={6}>
                  <Form.Item
                    label={
                      <span className="calculater-container-pikpin">
                        {" "}
                        Height (Cm)
                      </span>
                    }
                    name="height"
                  >
                    <Input
                      placeholder="Enter height"
                      maxLength={3}
                      disabled={true}
                      readOnly={true}
                      // disabled={createChildShipmentResult !== null && true}
                    />
                  </Form.Item>
                </Col>
                <Col lg={12} sm={6}>
                  <Form.Item label="Vol Weight (Kg)" name="totalVolWeight">
                    <Input
                      disabled={true}
                      readOnly={true}
                      type="number"
                      // disabled={createChildShipmentResult !== null && true}
                    />
                  </Form.Item>
                </Col>
              </>
            )}

            <Col lg={lg} sm={sm}>
              <Form.Item name="ewayBillNo" label="E-way bill no">
                <Input maxLength={12} placeholder="Enter here" />
              </Form.Item>
            </Col>
            <Col lg={lg} sm={sm}>
              <Form.Item name="gstNumber" label="Sender's GST number">
                <Input
                  maxLength={15}
                  disabled={true}
                  readOnly={true}
                  placeholder="Enter here"
                />
              </Form.Item>
            </Col>

            <Col lg={6} sm={sm}>
              <Form.Item name="cod" label="COD">
                <Radio.Group style={{ display: "flex", columnGap: "40px" }}>
                  <Radio value={"yes"}>Yes </Radio>
                  <Radio value={"no"}>No</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col lg={6} sm={sm}>
              <Form.Item name="fov" label="FOV">
                <Radio.Group style={{ display: "flex", columnGap: "40px" }}>
                  <Radio value={"yes"}>Yes </Radio>
                  <Radio value={"no"}>No</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
        </div>
        <div style={{ paddingTop: "20px" }}>
          <HeaderWithBottomLine text={"Upload Document"} icon={false} />
          {/* <h4>{UPLOAD_FILES}</h4> */}
          <ul>
            <li>
              Click the icon or drag and drop to upload supporting documents
            </li>
            <li>Supported file type: PDF, JPEG, PNG and Max 10MB file size</li>
          </ul>
          <Row className="upload_and_dragger">
            <Col>
              <div className="one-row">
                <Dragger
                  {...props}
                  className="dragger"
                  onChange={handleChange}
                  onRemove={handleRemove}
                  maxCount={10}
                  fileList={fileList}
                  beforeUpload={beforeUpload}
                  multiple={false}
                  headers={{
                    "SMCS-PREMISE-ID": userInfo?.premiseId,
                    awbNumber: allData?.awbNumber,
                    Authorization: authToken,
                  }}
                >
                  <Row>
                    <Col span={sm}>
                      <img src={uploadLogo} className="Upload_logo" />
                    </Col>
                    <Col span={1} className="vline"></Col>
                    <Col span={17}>
                      <p>Choose file</p>
                    </Col>
                  </Row>
                </Dragger>
              </div>
            </Col>
          </Row>
          <hr className="divider" style={{ marginTop: "20px" }} />

          <div className="d-flex flex-end mt-1">
            <Button
              className="btn-style cancel-btn ml-1 w-10"
              onClick={() => screen(2)}
            >
              BACK
            </Button>
            <Button
              htmlType="submit"
              className="btn-style save-btn ml-1"
              // onClick={handleStepsChange}
            >
              SUBMIT
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default ServiceDetails;
